export default __webpack_public_path__ + "static/media/AR-7.dc6e42b6.jpg";